import "./main_sec_0.css";
export default function main_sec_0() {
  return (
    <>
      <section className="main-sec_1" id="sec1">
        <h5 id="sec1_h3_1">
          WELCOME TO Orange Tree Education, Education Internship Project
        </h5>
      </section>
      <section className="main-sec_1" id="sec2">
        <p id="sec1_p_1">
          A joint venture of experienced professionals from software and
          training industry.
        </p>
      </section>
      <section className="main-sec_1" id="main-sec_1_button">
        <div id="div-btn">
          <a href="#COURSE">
            <button id="view_course_btn">VIEW COURSE</button>
          </a>
        </div>
      </section>
    </>
  );
}
